import { Autocomplete, TextField } from "@mui/material";
import { MRT_Row } from "material-react-table";
import { useTranslation } from "react-i18next";
import { BookingScheduleInterface } from "../../Booking-Form/typings/booking.types";
import { Colleague } from "../../Connections/types/Colleague.type";

type P = {
  row: MRT_Row<BookingScheduleInterface>;
  colleagues: Colleague[];
};

export function VisitorBookingsHostEdit({ row, colleagues }: P) {
  const { t } = useTranslation();
  const selected = colleagues.find(c => c.userId === row.original.userBookedBy) ?? null;

  return (
    <Autocomplete
      options={colleagues}
      value={selected}
      fullWidth
      getOptionLabel={option => `${option.firstName} ${option.surname}`.trim() || option.email}
      isOptionEqualToValue={(a, b) => a.userId === b.userId}
      onChange={(_, value) => {
        row._valuesCache.userBookedBy = value?.userId ?? "";
      }}
      renderInput={params => (
        <TextField
          {...params}
          variant="standard"
          label={t("_visitorBookings_colHost")}
          placeholder={t("_visitorBookings_colHost")}
        />
      )}
    />
  );
}
